/** Spojí metadata topiců (metricMeta) + živé hodnoty (values) → seznam pro knihovnu topiců. */

import { useMemo } from "react";
import { useMetricMetaStore } from "@client/store/metricMeta";
import { useValuesStore } from "@client/store/values";

export type TopicEntry = {
  topic: string;
  nickname: string;
  unit: string;
  valueType: string;
  decimals: number;
  lastValue?: number | boolean | string;
  lastAt?: number;
};

export const useAllTopics = (): TopicEntry[] => {
  const meta = useMetricMetaStore((s) => s.meta);
  const byTopic = useValuesStore((s) => s.byTopic);
  return useMemo(() => {
    const out: TopicEntry[] = [];
    for (const [topic, m] of meta) {
      const v = byTopic.get(topic);
      out.push({
        topic,
        nickname: m.nickname ?? "",
        unit: m.unit ?? "",
        valueType: String(m.valueType),
        decimals: m.decimals ?? 1,
        lastValue: v?.value,
        lastAt: v?.timestamp instanceof Date ? v.timestamp.getTime() : undefined,
      });
    }
    out.sort((a, b) => (a.nickname || a.topic).localeCompare(b.nickname || b.topic));
    return out;
  }, [meta, byTopic]);
};
